var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5157 17.7522C9.75984 18.5081 8.56299 18.5081 7.80709 17.7522L1.06693 10.823C0.311024 10.0671 0.311024 8.80729 1.06693 8.05138C1.82283 7.29548 3.01968 7.29548 3.77559 8.05138L9.12992 13.5947L21.2244 1.24823C21.9803 0.492329 23.1772 0.492329 23.9331 1.24823C24.689 2.00414 24.689 3.26398 23.9331 4.01989L10.5157 17.7522Z",
    fill: "#52C41A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTick);
export default __webpack_public_path__ + "static/media/icon-tick.09c48ea91a0ef456bbf9c39d4da1b4e5.svg";
export { ForwardRef as ReactComponent };